module.exports = __webpack_public_path__ + "img/am08.623da799.jpg";